/** Mirror of backend `com.kervolt.oms.enums.TnaMilestoneType` (garments T&A calendar). */
export type TnaMilestoneType =
    | 'PP_SAMPLE_APPROVED'
    | 'RAW_MATERIAL_IN_HOUSE'
    | 'CUTTING_START'
    | 'SEWING_START'
    | 'SEWING_END'
    | 'FINISHING'
    | 'FINAL_INSPECTION'
    | 'EX_FACTORY'
    | 'SHIPMENT';

/** Display labels mirroring `TnaMilestoneType#getDisplayLabel` — used when a milestone's own `displayLabel` is absent. */
export const TNA_MILESTONE_TYPE_LABELS: Record<TnaMilestoneType, string> = {
    PP_SAMPLE_APPROVED: 'PP Sample Approved',
    RAW_MATERIAL_IN_HOUSE: 'Raw Material In-House',
    CUTTING_START: 'Cutting Start',
    SEWING_START: 'Sewing Start',
    SEWING_END: 'Sewing End',
    FINISHING: 'Finishing',
    FINAL_INSPECTION: 'Final Inspection',
    EX_FACTORY: 'Ex-Factory',
    SHIPMENT: 'Shipment',
};

/** Mirror of backend `com.kervolt.oms.enums.TnaMilestoneStatus` — always derived, never stored. */
export type TnaMilestoneStatus = 'COMPLETED' | 'OVERDUE' | 'DUE_SOON' | 'ON_TRACK';

/** Mirror of backend `TnaMilestoneDTO`. */
export interface ITnaMilestone {
    id: string;
    buyerOrderId: string;
    milestoneType: TnaMilestoneType;
    displayLabel: string;
    sequence: number;
    offsetDays: number;
    targetDate?: string | null;
    actualDate?: string | null;
    completed: boolean;
    remarks?: string | null;
    status: TnaMilestoneStatus;
}

/** Mirror of backend `CreateTnaMilestoneRequest` — single-milestone add. */
export interface ICreateTnaMilestoneRequest {
    milestoneType: TnaMilestoneType;
    sequence?: number | null;
    offsetDays?: number | null;
    targetDate?: string | null;
    remarks?: string | null;
}

/** Mirror of backend `UpdateTnaMilestoneRequest` — full milestone edit + completion toggle. */
export interface IUpdateTnaMilestoneRequest {
    targetDate?: string | null;
    offsetDays: number;
    sequence: number;
    remarks?: string | null;
    completed: boolean;
    actualDate?: string | null;
}
